// COMPONENTS_ORDER is a dictionary that maps a category/subcategory to components, that should be rendered in a specific order.
import {
    CHRISTMAS_EVENTBRITE_SUB_CATEGORY,
    DATING_EVENTBRITE_SUB_CATEGORY,
    FALL_EVENTBRITE_SUB_CATEGORY,
    HALLOWEEN_EVENTBRITE_SUB_CATEGORY,
    INDEPENDENCE_DAY_EVENTBRITE_SUB_CATEGORY,
    LGBT_EVENTBRITE_SUB_CATEGORY,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
    NYE_EVENTBRITE_SUB_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    THANKSGIVING_EVENTBRITE_SUB_CATEGORY,
} from '@eventbrite/categories';
import { DATING_TAGS } from '../components/CategoryFilterBar/constants';

export const COMPONENTS_LABELS: { [key: string]: string } = {
    categoryTab: 'categoryTab',
    categoryBar: 'categoryBar',
    nightlifeCategories: 'nightlifeCategories',
    mostPopular: 'mostPopular',
    weekend: 'weekend',
    free: 'free',
    organizerToFollow: 'organizerToFollow',
    dynamicEvents0: 'dynamicEvents0',
    dynamicEvents1: 'dynamicEvents1',
    dynamicEvents2: 'dynamicEvents2',
    popularFormats: 'popularFormats',
    popularTimes: 'popularTimes',
    popularCategories: 'popularCategories',
    popularOrganizers: 'popularOrganizers',
    nearbyCities: 'nearbyCities',
    parties: 'parties',
    nightlife: 'nightlife',
    budgetFriendly: 'budgetFriendly',
    OrganizersTags: 'OrganizersTags',
    trendingTags: 'trendingTags',
    meetSomeoneNew: 'meetSomeoneNew',
    planDate: 'planDate',
    foodAndDrink: 'foodAndDrink',
    fineArts: 'fineArts',
    collectionTouchpoint: 'collectionTouchpoint',
    classes: 'classes',
};

export const COMPONENTS_ORDER: { [key: string]: string[] } = {
    default: [
        COMPONENTS_LABELS.categoryTab,
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.organizerToFollow,
        COMPONENTS_LABELS.dynamicEvents0,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.OrganizersTags,
        COMPONENTS_LABELS.dynamicEvents1,
        COMPONENTS_LABELS.dynamicEvents2,
        COMPONENTS_LABELS.popularFormats,
        COMPONENTS_LABELS.popularTimes,
        COMPONENTS_LABELS.popularCategories,
        COMPONENTS_LABELS.popularOrganizers,
        COMPONENTS_LABELS.nearbyCities,
    ],
    [NIGHTLIFE_EVENTBRITE_CATEGORY]: [
        COMPONENTS_LABELS.nightlifeCategories,
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.fineArts,
        COMPONENTS_LABELS.organizerToFollow,
        COMPONENTS_LABELS.nearbyCities,
    ],
    [SEASONAL_EVENTBRITE_CATEGORY]: [
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.collectionTouchpoint,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.nightlife,
        COMPONENTS_LABELS.budgetFriendly,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.dynamicEvents0,
        COMPONENTS_LABELS.dynamicEvents1,
    ],
    [DATING_EVENTBRITE_SUB_CATEGORY]: [
        COMPONENTS_LABELS.categoryBar,
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.collectionTouchpoint,
        COMPONENTS_LABELS.meetSomeoneNew,
        COMPONENTS_LABELS.planDate,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.foodAndDrink,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.classes,
        COMPONENTS_LABELS.fineArts,
    ],
    [LGBT_EVENTBRITE_SUB_CATEGORY]: [
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.nightlife,
        COMPONENTS_LABELS.collectionTouchpoint,
        COMPONENTS_LABELS.budgetFriendly,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.dynamicEvents0,
        COMPONENTS_LABELS.dynamicEvents1,
        COMPONENTS_LABELS.popularFormats,
        COMPONENTS_LABELS.popularTimes,
        COMPONENTS_LABELS.popularCategories,
        COMPONENTS_LABELS.nearbyCities,
        COMPONENTS_LABELS.organizerToFollow,
    ],
    [INDEPENDENCE_DAY_EVENTBRITE_SUB_CATEGORY]: [
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.budgetFriendly,
        COMPONENTS_LABELS.foodAndDrink,
        COMPONENTS_LABELS.collectionTouchpoint,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.organizerToFollow,
        COMPONENTS_LABELS.dynamicEvents0,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.dynamicEvents1,
        COMPONENTS_LABELS.dynamicEvents2,
        COMPONENTS_LABELS.popularFormats,
        COMPONENTS_LABELS.popularTimes,
        COMPONENTS_LABELS.popularCategories,
        COMPONENTS_LABELS.nearbyCities,
    ],
    [HALLOWEEN_EVENTBRITE_SUB_CATEGORY]: [
        COMPONENTS_LABELS.categoryTab,
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.weekend,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.budgetFriendly,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.nightlife,
        COMPONENTS_LABELS.organizerToFollow,
        COMPONENTS_LABELS.dynamicEvents0,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.dynamicEvents1,
        COMPONENTS_LABELS.dynamicEvents2,
        COMPONENTS_LABELS.popularFormats,
        COMPONENTS_LABELS.popularTimes,
        COMPONENTS_LABELS.popularCategories,
        COMPONENTS_LABELS.nearbyCities,
    ],
    [NYE_EVENTBRITE_SUB_CATEGORY]: [
        COMPONENTS_LABELS.mostPopular,
        COMPONENTS_LABELS.free,
        COMPONENTS_LABELS.weekend,
        // COMPONENTS_LABELS.collectionTouchpoint,
        COMPONENTS_LABELS.parties,
        COMPONENTS_LABELS.nightlife,
        COMPONENTS_LABELS.budgetFriendly,
        COMPONENTS_LABELS.trendingTags,
        COMPONENTS_LABELS.dynamicEvents0,
        COMPONENTS_LABELS.dynamicEvents1,
    ],
};

interface CategoryHeaderCustomProps {
    ctaBackground?: string;
    imageClass?: string;
    showDateFilter?: boolean;
    title: string;
    showLocationPill: boolean;
    containerClass?: string;
    showStickyHeader?: boolean;
    queryActiveTags?: string[];
    showAddToInterestBtn?: boolean;
}

export const CUSTOM_CATEGORY_HEADER: {
    [key: string]: CategoryHeaderCustomProps;
} = {
    [DATING_EVENTBRITE_SUB_CATEGORY]: {
        ctaBackground: 'ghost-theme',
        imageClass: 'category-browse--header-image--square',
        showDateFilter: false,
        showLocationPill: true,
        showStickyHeader: false,
        title: "IT'S A DATE",
        containerClass: 'dating-container',
        queryActiveTags: DATING_TAGS,
        showAddToInterestBtn: false,
    },
    [LGBT_EVENTBRITE_SUB_CATEGORY]: {
        ctaBackground: 'secondary-theme',
        imageClass: 'category-browse--header-image--square',
        showLocationPill: false,
        title: 'Find Your Pride',
    },
    [NIGHTLIFE_EVENTBRITE_CATEGORY]: {
        title: 'NIGHTLIFE',
        imageClass: 'category-browse--header-image--rounded',
        showLocationPill: true,
        showStickyHeader: false,
        showDateFilter: false,
        containerClass: 'nightlife-container',
    },
    [HALLOWEEN_EVENTBRITE_SUB_CATEGORY]: {
        title: 'Halloween Events',
        showLocationPill: false,
    },
    [SEASONAL_EVENTBRITE_CATEGORY]: {
        title: 'Holiday Events',
        imageClass: 'category-browse--header-image--rounded',
        showLocationPill: false,
        containerClass: 'seasonal-container holiday',
    },
    [THANKSGIVING_EVENTBRITE_SUB_CATEGORY]: {
        title: 'Thanksgiving Events',
        imageClass: 'category-browse--header-image--rounded',
        showLocationPill: false,
        containerClass: 'seasonal-container',
    },
    [FALL_EVENTBRITE_SUB_CATEGORY]: {
        title: 'Fall Events',
        imageClass: 'category-browse--header-image--rounded',
        showLocationPill: false,
        containerClass: 'seasonal-container',
    },
    [CHRISTMAS_EVENTBRITE_SUB_CATEGORY]: {
        title: 'Christmas Events',
        imageClass: 'category-browse--header-image--rounded',
        showLocationPill: false,
        containerClass: 'seasonal-container',
    },
    [NYE_EVENTBRITE_SUB_CATEGORY]: {
        title: `New Year's Eve events`,
        imageClass: 'category-browse--header-image--rounded',
        showLocationPill: false,
        containerClass: 'seasonal-container',
    },
};
